import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findJobs = (headers, params) => {
    const dataParams = {
        ...params,
        filters: {
            ...params.filters,
            type: {
                value: "05",
                matchMode: "equals",
            },
        },
    };
    let query = buildQuery(dataParams, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/sysCategory${query}`, {
        headers,
    });
};

export const findJobById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/sysCategory/${id}`, {
        headers,
    });
};
